import React, {useState} from "react";
import {Button, FormControl, IconButton, InputLabel, OutlinedInput, Typography, withStyles} from "@material-ui/core";
import clsx from "clsx";
import {blockInvalidChar} from "../../sc-utilities";
import {Delete} from "@material-ui/icons";
import PriceListModal from "./PriceListModal";

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: "wrap",
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: theme.spacing(3)
    },
    margin: {
        margin: theme.spacing(1)
    },
    withoutLabel: {
        marginTop: theme.spacing(3)
    },
    textField: {
        width: "25ch"
    },
    span: {
        position: "relative",
        top: "20px"
    },
    row: {
        display: 'row',
        width: "auto",
        alignItems: 'center'
    },
    typo: {
        position: 'relative',
        display: 'inline',
        padding: theme.spacing(2),
    },
    typo2: {
        position: 'relative',
        display: 'inline',
        padding: theme.spacing(2),
        marginLeft: '24rem'
    },
    btn: {
        width: '98%',
        marginLeft: '0.5rem',
        marginRight: '0.5rem'
    },
    title: {
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        fontSize: '150%',
        position: 'relative',
        display: 'flex',
        padding: theme.spacing(2),
    },
    to: {
        backgroundColor: 'rgb(246,246,246)'
    },
    deleteRow: {
        position: "relative",
        top: "15px"
    },
    error: {
        marginLeft: "10px",
        color: 'red',
        fontSize: "14px",
    }
});

const PlanFormPricelist = (props) => {
    const {classes, values, translations, errors, handleChange, priceListName, setFieldValue} = props;
    const [open, setOpen] = useState(false);

    const priceError = translations['price_must_be_greater_than_0'] || "Price must be greater than 0! ";
    const fromError = translations['from_is_a_required_field'] || "From is a required field! ";

    const blurDialog = (index) => {
        if (index===values[priceListName].length-1 && values[priceListName][index].from==="") {
            setOpen(true);
        }
    }

    const addNewRow = () => {
        const lastIndex = values[priceListName]?.length-1 ?? 0;
        const lastValue = values[priceListName]?.[lastIndex] ?? { from: 0 };
        setFieldValue(priceListName, [...values[priceListName] ?? [], { 'from': lastValue?.from+1 || 0, 'to': null, 'price': 0.1 }]);
        setFieldValue(`${priceListName}[${lastIndex}].to`, lastValue?.from)
    }

    const deleteRow = (index) => {
        if (index===1 && values[priceListName].length===2) {
            setFieldValue(priceListName, [{'from': values[priceListName][index-1].from, 'to': null, 'price': values[priceListName][index-1].price}]);
        } else {
            setFieldValue(priceListName, values[priceListName].filter((value, i) => i!==index));
        }
        const afterDeleted = values[priceListName][index+1]?? null;
        if (afterDeleted) {
            setFieldValue(`${priceListName}[${index-1}].to`, afterDeleted.from-1);
        }
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleDeleteLastTo = () => {
        const lastIndex = values[priceListName].length-1;
        setFieldValue(`${priceListName}[${lastIndex}].to`, null)
        setFieldValue(priceListName, values[priceListName].filter((value, i) => i!==values[priceListName].length-1));
        setOpen(false);
    };

    return (
        <div className={classes.root}>
            <div className={classes.row}>
                <Typography variant="h6" className={classes.title}>
                    {translations[priceListName?.toLowerCase()] || priceListName}{" "}{translations['price_list'] || 'Price list'}
                </Typography>
                <div>
                    <Typography variant="h6" className={classes.typo}>
                        {translations['range'] || "Range"}
                    </Typography>
                    <Typography variant="h6" className={classes.typo2}>
                        {translations['price'] || "Price"}
                    </Typography>
                </div>

                {values[priceListName]?.map((value, index) => {
                    return (
                    <div key={index}>
                        <FormControl
                            className={clsx(classes.margin, classes.textField)}
                            variant="outlined"
                        >
                            <InputLabel htmlFor="from">{translations['from'] || 'From'}</InputLabel>
                            <OutlinedInput
                                name={`${priceListName}[${[index]}].from`}
                                label={translations['from'] || 'From'}
                                type="number"
                                onKeyDown={blockInvalidChar}
                                value={value.from?? 0}
                                // autoFocus={setAutoFocus({ index, el })}
                                onBlur={() => blurDialog(index)}
                                onChange={e => {
                                    if (e.target.value>values[priceListName][index-1]?.from) {setFieldValue(`${priceListName}[${[index-1]}].to`, Number(e.target.value)-1)}
                                    handleChange(e);
                                }
                                }
                                inputProps={{
                                    min: 0,
                                }}
                                labelWidth={0}
                            />
                        </FormControl>
                        <span className={classes.span}>-</span>
                        <FormControl
                            className={clsx(classes.margin, classes.textField)}
                            variant="outlined"
                        >
                            <InputLabel htmlFor="to">{translations['to'] || 'To'}</InputLabel>
                            <OutlinedInput
                                className={classes.to}
                                name={`${priceListName}[${[index]}].to`}
                                onKeyDown={blockInvalidChar}
                                type={'number'}
                                label={translations['to'] || 'To'}
                                value={index===values[priceListName].length-1? '' : value.to?? 0}
                                onChange={handleChange}
                                inputProps={{
                                    min: values[priceListName][index].from,
                                    readOnly: true,
                                    "aria-label": "to"
                                }}
                                labelWidth={0}
                            />
                        </FormControl>

                        <span className={classes.span}>=</span>
                        <FormControl
                            className={clsx(classes.margin, classes.textField)}
                            variant="outlined"
                        >
                            <OutlinedInput
                                name={`${priceListName}[${[index]}].price`}
                                type={'number'}
                                onKeyDown={blockInvalidChar}
                                value={value.price?? 0}
                                onChange={handleChange}
                                aria-describedby="outlined-weight-helper-text"
                                inputProps={{
                                    "aria-label": "Price",
                                    step: "any",
                                    min: 0.1
                                }}
                                labelWidth={0}
                            />
                        </FormControl>
                        <IconButton
                            className={classes.deleteRow}
                            aria-label={translations["delete"] || "Delete"}
                            onClick={() => deleteRow(index)}
                        >
                            <Delete />
                        </IconButton>
                    </div>
                    )})}
                {errors && errors[priceListName] && typeof errors[priceListName]==="string" && <span className={classes.error}>{errors[priceListName]}</span>}
                {errors && errors[priceListName] && typeof errors[priceListName]!=="string" && <span className={classes.error}>{errors[priceListName]?.map((value) => value?.to || (value?.from? fromError: '') || (value?.price? priceError: '') || value)}</span>}
                <Button className={classes.btn} color="primary" variant="contained" disabled={errors && errors[priceListName]?.length > 0} onClick={() => addNewRow()}>{translations['add_new_range'] || 'Add new range'}</Button>
                <PriceListModal open={open} entityName={priceListName} key={priceListName.toLowerCase()} translations={translations} handleClose={handleClose} handleDeleteLastTo={handleDeleteLastTo} />
            </div>
        </div>
    )
}

export default withStyles(styles, { withTheme: true })(PlanFormPricelist);